import { render, staticRenderFns } from "./contact-request-commerce7-manual-edit.vue?vue&type=template&id=06dc7864&scoped=true&"
import script from "./contact-request-commerce7-manual-edit.vue?vue&type=script&lang=js&"
export * from "./contact-request-commerce7-manual-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dc7864",
  null
  
)

export default component.exports